import { useEffect, useState } from "react";
import { IconMoonStars, IconSun } from "@tabler/icons";
import "./index.css";

const timeline = [
  {
    year: "2016–2020",
    title: "B.Tech in Computer Science and Engineering",
    copy: "Studied Computer Science and Engineering at the Indian Institute of Technology Bhubaneswar.",
    href: "https://www.iitbbs.ac.in",
  },
  {
    year: "2018",
    title: "Google Summer of Code",
    copy: "Worked with CERN-HSF on large-scale batch computing orchestration and visualization through Jupyter Notebook.",
    href: "https://summerofcode.withgoogle.com/archive/2018/projects/4671150864990208",
  },
  {
    year: "College",
    title: "Hackathons and competitions",
    copy: "Won first prize at Smart India Hackathon and third prize at the Inter IIT Tech Meet with my team.",
    href: "https://twitter.com/apsknight_/status/1102099261716520960?s=20",
  },
  {
    year: "Summer 2019",
    title: "Amazon internship",
    copy: "Spent the summer interning at Amazon in Bangalore.",
  },
  {
    year: "2020",
    title: "Joined Amazon",
    copy: "Started my professional career at Amazon as an SDE-1.",
  },
  {
    year: "July 2022",
    title: "Promoted to SDE-2",
    copy: "Continued building and operating distributed and serverless systems at Amazon.",
  },
  {
    year: "Nov 2024",
    title: "Moved to Bellevue",
    copy: "Moved from Bangalore to Bellevue, Washington, and started exploring the trails of the Pacific Northwest.",
  },
  {
    year: "Now",
    title: "Amazon SageMaker AI",
    copy: "Working on SageMaker HyperPod and building resilient clusters for large-scale LLM training and inference.",
  },
];

function App() {
  const [theme, setTheme] = useState<"light" | "dark">(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "light" || savedTheme === "dark") return savedTheme;
    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  });

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem("theme", theme);
  }, [theme]);

  return (
    <main className="page">
      <button
        className="theme-toggle"
        onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
        aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      >
        {theme === "dark" ? (
          <IconSun size={18} />
        ) : (
          <IconMoonStars size={18} />
        )}
      </button>

      <header className="intro">
        <p className="hello">Hello, I’m</p>
        <h1>Aman Pratap Singh.</h1>
        <p className="lede">
          I’m a software engineer living in Bellevue, Washington. I work as an
          SDE-2 at Amazon SageMaker AI, where I help build resilient clusters
          for large-scale LLM training and inference on{" "}
          <a
            href="https://aws.amazon.com/sagemaker/hyperpod/"
            target="_blank"
            rel="noreferrer"
          >
            SageMaker HyperPod
          </a>
          .
        </p>
        <p>
          Outside work, I’m usually hiking somewhere in the Pacific Northwest
          or browsing enough AI conversations on X and YouTube to induce a
          little AI psychosis.
        </p>
      </header>

      <section className="timeline-section">
        <h2>My timeline</h2>
        <div className="timeline">
          {timeline.map((item) => (
            <article className="timeline-item" key={`${item.year}-${item.title}`}>
              <p className="year">{item.year}</p>
              <div>
                <h3>{item.title}</h3>
                <p>{item.copy}</p>
                {item.href && (
                  <a href={item.href} target="_blank" rel="noreferrer">
                    More about this ↗
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>
      </section>

      <footer>
        <p>
          You can find me on{" "}
          <a href="https://twitter.com/apsknight_" target="_blank" rel="noreferrer">
            X
          </a>
          ,{" "}
          <a href="https://github.com/apsknight" target="_blank" rel="noreferrer">
            GitHub
          </a>
          ,{" "}
          <a
            href="https://www.linkedin.com/in/amanprsingh/"
            target="_blank"
            rel="noreferrer"
          >
            LinkedIn
          </a>
          , and{" "}
          <a href="https://medium.com/@amanpratapsingh" target="_blank" rel="noreferrer">
            Medium
          </a>
          , or reach me by{" "}
          <a href="mailto:amanpratapsingh@outlook.com">email</a>.
        </p>
      </footer>
    </main>
  );
}

export default App;
